interface IProps extends React.InputHTMLAttributes<HTMLInputElement> {
  label: string;
  register?: any;
  errorMessage?: string;
}

export function Checkbox({
  label,
  className,
  register,
  id,
  errorMessage,
  ...rest
}: IProps) {
  return (
    <div className="form-check">
      <input
        className={`form-check-input cursor-pointer ${className ?? ""} ${errorMessage ? "is-invalid" : ""}`}
        type="checkbox"
        id={id}
        {...register}
        {...rest}
      />
      <label htmlFor={id} className="form-check-label cursor-pointer">
        {label}
      </label>
      {errorMessage && <div className="invalid-feedback">{errorMessage}</div>}
    </div>
  );
}
